var map = {
	"./C++_512.png": 777,
	"./C_512.png": 571,
	"./Git_512.png": 529,
	"./HTML_512.png": 357,
	"./JavaScript_512.png": 52,
	"./Java_512.png": 144,
	"./Linux_512.png": 522,
	"./MongoDB_512.png": 372,
	"./MySQL_512.png": 91,
	"./NodeJS_512.png": 817,
	"./Python_512.png": 816,
	"./React_512.png": 298,
	"./SQL_512.png": 869,
	"./Tailwind_512.png": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255;